import styled from 'styled-components';

const ViewAnnotation = styled.div`
  .carousel-control svg {
    position: relative;
    top: 50%;
  }
`;

export default {
  ViewAnnotation
};
